import Client from './client';

export default class BrowserBundles extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/bundles/browser`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/bundles/browser`, {
      ...options,
       method: 'POST',
    });
  }

}
